import Vue from 'vue';
import Vuex from 'vuex';
// Vuex modules
// Data model stores
import account from './modules/account';
import agreement from './modules/agreement';
import submission from './modules/submission';
import submissionProgress from './modules/submissionProgress';
import uploadQueue from './modules/uploadQueue';
// Service stores
import dialogue from './modules/dialogue';
import layout from './modules/layout';
import networkActivity from './modules/networkActivity';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  modules: {
    account,
    agreement,
    submission,
    submissionProgress,
    uploadQueue,

    dialogue,
    layout,
    networkActivity,
  },
  strict: process.env.NODE_ENV !== 'production',
});



// WEBPACK FOOTER //
// ./src/store/index.js